export enum EntityType {
    Service = 1,
    Space = 2,
    Organization = 3,
    AdaptationPlan = 4
}
